import { isEmailInput, cleanEmailString, isValidEmail, insertTextIntoInput } from './emailHelper.js';

/**
 * Global paste event listener that intercepts paste on email fields
 * and strips formatted email strings (e.g. "Rifat Ahmed Khan <Rifat@vertexcybersecurity.com.au>")
 * down to just the clean email address.
 *
 * @param {ClipboardEvent} event
 */
export function handleGlobalEmailPaste(event) {
    const target = event.target;
    if (!target) return;

    // If target has a dedicated multi-email chip/pill handler, let component handler manage it
    if (target.classList && target.classList.contains('email-input-field')) {
        return;
    }

    // Check if the target is an email input field
    if (!isEmailInput(target)) {
        return;
    }

    // Retrieve clipboard text
    const clipboardData = event.clipboardData || window.clipboardData;
    if (!clipboardData) return;

    const pastedText = clipboardData.getData('text') || clipboardData.getData('text/plain');
    if (!pastedText) return;

    const cleaned = cleanEmailString(pastedText);

    // If an email address was extracted or the pasted text was cleaned
    if (cleaned && (isValidEmail(cleaned) || cleaned !== pastedText)) {
        event.preventDefault();
        event.stopPropagation();
        insertTextIntoInput(target, cleaned);
    }
}

let isInitialized = false;

/**
 * Initializes the global email paste listener on the window.
 */
export function initEmailPasteHandler() {
    if (typeof window === 'undefined' || isInitialized) return;
    window.addEventListener('paste', handleGlobalEmailPaste, true);
    isInitialized = true;
}

export default {
    install(app) {
        initEmailPasteHandler();
        
        // Register custom directive v-clean-email if components want explicit directive usage
        app.directive('clean-email', {
            mounted(el) {
                const inputEl = el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' ? el : el.querySelector('input, textarea');
                if (!inputEl) return;
                
                inputEl.addEventListener('paste', (e) => {
                    const clipboardData = e.clipboardData || window.clipboardData;
                    if (!clipboardData) return;
                    const text = clipboardData.getData('text') || clipboardData.getData('text/plain');
                    if (!text) return;
                    const cleaned = cleanEmailString(text);
                    if (cleaned && (isValidEmail(cleaned) || cleaned !== text)) {
                        e.preventDefault();
                        e.stopPropagation();
                        insertTextIntoInput(inputEl, cleaned);
                    }
                });
            }
        });
    }
};
